import gsap from 'gsap';

const timelineToggle = (timeline) => {
    if(timeline.progress() < 1){
        timeline.play();
    } else {
        timeline.restart();
    }
}

const openMenu = (target) => {

    const open = gsap.timeline({
        paused: true,
    });

    open
        .staggerTo('.header__overlay', 0.2, {
            opacity: 1,
            ease: "easeInOut",
            display: "block",
        }, 0.1)
        .staggerTo(target.find('.nav-item'), 0.5, {
            x: 0,
            opacity: 1,
            ease: "easeInOut",
        }, 0.1)

    timelineToggle(open);
}

const closeMenu = (target) => {

    const close = gsap.timeline({
        paused: true,
    });

    close
        .staggerTo('.header__overlay', 0.2, {
            opacity: 0,
            ease: "easeInOut",
            display: "none",
        }, 0.1)
        .staggerTo(target.find('.nav-item'), 0.5, {
            x: 100,
            opacity: 0,
            ease: "easeInOut",
        }, 0.1)

    timelineToggle(close);
}

const toggleDropdown = (el) => {
    // if (window.innerWidth > 767) {
    //     if(el.hasClass('active')){
    //         closeMenu($(el).next());
    //     } else {
    //         openMenu($(el).next());
    //     }
    // }

    if(el.hasClass('active')){
        closeMenu($(el).next());
    } else {
        openMenu($(el).next());
    }

    $(el).next().slideToggle();
    $(el).find('.fas').toggleClass('fa-plus fa-minus');
    $(el).toggleClass('active');
}

$(document).on('click', '.dropdown-menu-toggler', function() {
    $('.dropdown-menu-toggler.active').not($(this)).each(function() {
        toggleDropdown($(this));
    });

    toggleDropdown($(this));
});
